import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

import Slider from "react-slick";

const OurUniqueness = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const S3_URL = `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public`;

  const images = [
    "/Images/unique-1.jpg",
    "/Images/unique-2.jpg",
    "/Images/unique-3.jpg",
    "/Images/unique-4.jpg",
    "/Images/unique-5.jpg",
    "/Images/unique-6.jpg",
    "/Images/unique-7.jpg",
    "/Images/unique-8.jpg",
    "/Images/unique-9.jpg",
    "/Images/unique-10.jpg",
  ];

  useEffect(() => {
    document.title =
      "Our Uniqueness -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> About Us </li>
          <li> Our Uniqueness </li>
        </ul>
      </div>
      <div className="innersec uniqueness_sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Our Uniqueness </h1>
            </div>
          </div>
          <Slider {...settings}>
            {images.map((img, index) => (
              <div key={index} className="slick_img_uniquness">
                <img
                  src={`${S3_URL}${img}`}
                  alt={`unique-${index}`}
                  className="w-full rounded-lg"
                />
              </div>
            ))}
          </Slider>

          <div className="row">
            <div className="col-lg-12">
              <p>
                At St. Peter’s Convent School, we pride ourselves on offering a
                comprehensive and nurturing educational experience. Here’s what
                makes us unique:
              </p>
              <h6 className="heading"> Outstanding Academic Reputation </h6>
              <p>
                {" "}
                Known for our commitment to academic excellence and student
                success.{" "}
              </p>
              <h6 className="heading"> Value-Based Education </h6>
              <p>
                {" "}
                We are the only school that integrates value education as a core
                principle, with a dedication to fostering social
                transformation.{" "}
              </p>
              <h6 className="heading"> Expansive Campus </h6>
              <p>
                {" "}
                Our 10,912 sq. meter campus is equipped with well-maintained
                infrastructure, offering an ideal environment for learning and
                development.{" "}
              </p>
              <h6 className="heading">
                {" "}
                60+ Classrooms with Blended Learning Spaces{" "}
              </h6>
              <p>
                {" "}
                We provide modern, interactive classrooms designed for blended
                learning to engage students in dynamic ways.{" "}
              </p>
              <h6 className="heading"> Enhanced Safety Measures </h6>
              <p>
                {" "}
                With over 200 CCTV cameras across the campus and school buses
                with surveillance, we ensure a secure environment for all
                students.{" "}
              </p>
              <h6 className="heading"> Magnificent Auditorium </h6>
              <p>
                {" "}
                Our school features a state-of-the-art auditorium with a seating
                capacity of 1,200, perfect for hosting events and
                activities.{" "}
              </p>
              <h6 className="heading"> Vast Playground </h6>
              <p>
                {" "}
                Our 5,720 sq. meter playground offers ample space for sports and
                physical activities, promoting a healthy lifestyle.{" "}
              </p>
              <h6 className="heading"> Advanced Laboratories </h6>
              <p>
                {" "}
                We have 5 fully equipped modern science and computer labs,
                providing hands-on learning experiences in a range of
                disciplines.{" "}
              </p>
              <h6 className="heading">
                {" "}
                Transportation with Safety Surveillance{" "}
              </h6>
              <p>
                {" "}
                Our 7 school buses are equipped with CCTV to ensure student
                safety during commutes.{" "}
              </p>
              <h6 className="heading"> Large Student Community </h6>
              <p>
                {" "}
                With over 1,800 students, we offer a vibrant and diverse
                community that fosters learning and collaboration.{" "}
              </p>
              <h6 className="heading"> Highly Qualified Faculty </h6>
              <p>
                {" "}
                Our team consists of 80+ experienced and dedicated educators,
                ensuring top-quality teaching across all subjects.{" "}
              </p>
              <h6 className="heading"> Competency-Based Learning </h6>
              <p>
                {" "}
                We emphasize competency-based learning, encouraging students to
                apply knowledge and skills in real-world contexts.{" "}
              </p>
              <h6 className="heading">
                {" "}
                Experiential & Art-Integrated Education{" "}
              </h6>
              <p>
                {" "}
                Our curriculum includes experiential and art-integrated
                approaches, fostering creativity and critical thinking.{" "}
              </p>
              <h6 className="heading"> Spacious Library </h6>
              <p>
                {" "}
                Our central library houses more than 12,000 books, providing a
                rich resource for academic and personal growth.{" "}
              </p>
              <h6 className="heading"> School Counsellors </h6>
              <p>
                {" "}
                We have dedicated counsellors to support the physical and mental
                well-being of our students, ensuring balanced development.{" "}
              </p>
              <h6 className="heading"> Medical Room </h6>
              <p>
                {" "}
                A fully equipped medical room with qualified staff is available
                to address any health concerns promptly.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OurUniqueness;
